import { useNavigate } from "react-router-dom";
import Modal from "../components/Modal";
import { useState } from "react";
import RulesModal from "../components/Modals/RulesModal";

export default function ({ isOpen, setIsOpen }) {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const navigate = useNavigate();
    const [isOpenRules, setIsOpenRules] = useState(false);

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                size="xl"
            >
                <div className={"row"}>

                    <div className="col-xl-12">
                        <div className="col-12 mb-1">
                            <p>
                                کاربر عزیز سلام
                            </p>
                            <p>
                                به کارسود خوش آمدید😊🌹
                            </p>
                            <p>
                                اگر می‌خواهید در مورد قسمت‌های مختلف کارسود اطلاعات کسب کنید یا درمورد هر قسمتی سوال
                                دارید ، میتوانید روی علامت راهنما
                                <i className={"bx bx-help-circle text-success"}></i> در آن قسمت کلیک کنید و اطلاعات مربوط
                                به آن را مطالعه کنید
                            </p>
                            <hr />
                            <p>
                                ⚠️ نکته بسیار مهم: ثبتنام، ایجاد حساب کاربری و آغاز فعالیت در کارسود کاملا رایگان میباشد
                                <br />
                                خرید هر نوع محصول، خدمات و یا فعالسازی طرح های درآمدی نیز کاملا اختیاری و بر اساس تمایل، اراده و نیاز شخصی شما خواهد بود
                                <br />
                                تاکید میکنیم قبل از اقدام به فعال سازی هر یک از طرح های درآمدی و همچنین قبل از انجام هر گونه تراکنش یا فعالیت در سامانه کارسود، مطالعه دقیق{" "}

                                <a
                                    href="#"
                                    onClick={() => setIsOpenRules(true)}
                                    style={{ color: "#0d6efd", fontWeight: "bold", cursor: "pointer" }}
                                >
                                    قوانین و مقررات
                                </a>

                                {" "}سامانه، راهنما و کانال های آموزشی و اطلاع رسانی به جهت آگاهی و اطلاعات کامل شما از نحوه فعالیت و کسب درآمد پیش از هر اقدامی کاملا الزامی می باشد
                            </p>
                            <p>
                                توضیح کلی در مورد کارسود و نحوه کسب درآمد👇
                            </p>
                            <p className={"text-center"}>
                                <button className={'btn btn-primary me-3   bg-primary centered color-white'}
                                    onClick={() => setIsOpenModal(true)}>مطالعه توضیحات
                                </button>
                            </p>
                            <hr />
                            <p>
                                ابتدا توضیحات کلی داده شده در بالا را مطالعه کنید و سپس برای یادگیری جزئیات کار و
                                اطلاعات بیشتر عضو کانال‌های آموزشی و کانال‌های اطلاع رسانی شوید
                            </p>
                            <p className={"text-center"}>
                                <button className={'btn btn-primary me-3   bg-primary centered color-white'}
                                    onClick={() => navigate('/contact-us')}>عضویت در کانال ها
                                </button>
                            </p>


                        </div>

                    </div>

                </div>
            </Modal>

            <RulesModal
                isOpen={isOpenRules}
                setIsOpen={setIsOpenRules}
            />

            <Modal
                isOpen={isOpenModal}
                onClose={() => setIsOpenModal(false)}
                size="xl"
            >
                <div className={"row"}>

                    <div className="col-xl-12">
                        <div className="col-12 mb-1">


                            <p className={"pt-3"}>
                                《 لطفا مطالب رابادقت مطالعه کنید 》</p>


                            <p>👈کارسود یک وبسایت تبلیغات کلیکی، خدماتی، و کسب درآمد است که شما می‌توانید از آن
                                درآمد کسب
                                نمایید و هم خدمات مورد نیازتان را از آن استفاده نمایید.</p>
                            <p>👈 یکی از راه‌های کسب درآمد، کلیک تبلیغات است. کارسود در ازای فعالیت شما و استفاده
                                از
                                خدمات آن، به شما تبلیغات با درآمد و کارمزد مشخص می‌دهد و شما با کلیک کردن و
                                مشاهده این
                                تبلیغات کارمزد دریافت می‌نمایید.</p>
                            <p>🔸️ابتدا تعداد تبلیغات، کارمزد و درآمد شما از کلیک هر تبلیغ، اندک و ناچیز است ولی
                                به مرور
                                بعد از مدتی با افزایش فعالیت شما در کارسود، تبلیغات بیشتر با کارمزد و درآمد
                                بالاتر به
                                شما داده خواهد شد و به مرور درآمد شما افزایش پیدا می‌کند یعنی هرچه بیشتر در
                                کارسود
                                فعالیت داشته باشید و از خدمات مختلف آن استفاده کنید علاوه بر اینکه تبلیغات
                                بیشتری
                                می‌گیرید، کارمزدی که از کلیک هر تبلیغ دریافت می‌کنید مبلغ آن بیشتر می‌شود.</p>
                            <p>🔸️در ابتدا بابت کلیک روی هر تبلیغ مبلغ ۱۰ تومان (۱۰۰ ریال) کارمزد دریافت می‌کنید
                                و اگر فعال باشید، به مرور این مبلغ با فعالیت شما افزایش پیدا می‌کند و علاوه بر
                                این، کارمزدهای ۲۵ تومانی، ۵۰ تومانی، ۱۰۰ تومانی،۲۰۰ تومانی،۵۰۰ تومانی،
                                ۱۰۰۰تومانی، ۲۰۰۰تومانی و بالاتر نیز، بابت کلیک روی هر تبلیغ به شما پرداخت خواهد
                                شد</p>
                            <p>🔸️درآمد روزانه شما در ابتدا حداقل از ۵۰ تومان (۵۰۰ ریال) شروع شده و به مرور تا
                                روزی ۲.۰۰۰.۰۰۰ میلیون تومان(دو میلیون تومان) می‌تواند افزایش پیدا کند.</p>
                            <p>⭕️چرا در ابتدای ثبت نام، درآمد شما کمه، آیا ارزش داره که با این مبالغ کار
                                کنید⁉️</p>
                            <p> در همه جای دنیا شما هر کار درست، اصولی، واقعی و آینده‌دار را که شروع بکنید،
                                ابتدا درآمدتون کمه و با تلاشتون پله پله و به مرور درآمدتون زیاد میشه، حالا اینجا
                                در کارسود هم به همین شکله، ابتدا یک درآمد محدود و کم دارید و اگر فعال باشید،
                                درآمدتون به مرور افزایش پیدا می‌کنه و حتی می‌تونید تا روزی ۲ میلیون تومان در
                                آینده درآمد داشته باشید</p>
                            <p>🔸️ با فعال کردن "طرح‌های درآمدی"( استخرهای تبلیغات) در قسمت "داشبورد" و "طرح‌های فروش
                                بیمه"، تعداد تبلیغات شما و کارمزدی که از کلیک هر تبلیغ می‌گیرید و مبالغی که به
                                شما پاداش داده می‌شود به صورت چشمگیری افزایش پیدا می‌کند و در یک بازه زمانی یک
                                ماهه تا یک ساله، بسته به فعالیت شما، روزانه بین ۵۰۰ هزار تومان الی ۲ میلیون
                                تومان، می‌توانید تبلیغ ببینید و درآمد کسب کنید، یعنی تا ماهی ۶۰ میلیون تومان</p>
                            <p>🔸️همچنین اگر می‌خواهید حرفه‌ای کار کنید و درآمدهای بالایی را داشته باشید،
                                می‌توانید با
                                فعالیت در طرح‌های دیگر مانند طرح بیمه که به زودی به کارسود اضافه میشود به عنوان نماینده فروش بیمه درآمدهای
                                بسیار بالا و
                                نامحدودی را تجربه نمایید.</p>
                            <p>
                                نکته مهم: میزان درآمد کسب‌شده از این طرح‌ها به‌طور مستقیم متناسب با میزان فعالیت، مشارکت و عملکرد شما می‌باشد.
                                <br />
                                لازم به ذکر است که روند رشد درآمد همواره صعودی و یکنواخت نخواهد بود و ممکن است براساس عواملی مانند سطح فعالیت شما، میزان درآمدهای کسب‌شده توسط کارسود، وضعیت کلی طرح و سایر متغیرهای موثر، دچار نوسان و تغییر (کاهش یا افزایش) گردد؛ حتی در برخی موارد ممکن است روند درآمد برای مدتی متوقف گردد

                                <br />
                                نکته کلیدی: با حفظ فعالیت مستمر، پایبندی، پیروی و عمل به آموزش‌های ارائه شده و ارتقاء سطح عملکرد، پتانسیل قابل توجهی برای رشد پیوسته و پایدار درآمد شما فراهم است و در بلندمدت، می‌توان انتظار داشت که برآیند کلی درآمد شما همواره در حال افزایش باشد.
                                نتیجه نهایی: انتظار رشد مداوم و نامحدود درآمد، یا برعکس، کاهش و توقف دائمی آن، تصوری نادرست است. نمودار درآمد در طرح‌های «کارسود» که شامل افزایش، کاهش و دوره‌های توقف می‌شود، کاملاً طبیعی و قابل انتظار است. این نوسانات تابعی از عوامل متعددی است که بر عملکرد کلی طرح تأثیر می‌گذارند.
                            </p>
                            <p>👈خدمات موجود در کارسود خدمات کاربردی و مورد نیاز روزمره شماست، به عنوان مثال خرید
                                شارژ
                                تلفن همراه ، خرید بسته اینترنتی، پرداخت قبوض،خرید از فروشگاه آنلاین، خرید از فروشگاه‌هایی که با کارسود
                                قرارداد
                                دارند، خرید انواع بیمه نامه ها، بلیط قطار، اتوبوس و هواپیما، تورهای مسافرتی
                                داخلی و
                                خارجی، خرید آموزش‌های کاربردی صوتی و تصویری، خرید از فروشگاه‌ها و کسب و کارهای
                                طرف
                                قرارداد که کارسود آنها را تبلیغ می‌کند و کلی خدمات و امکانات دیگر که بخشی از
                                آنها روی
                                کارسود قرار گرفته و بخشی دیگر در حال آماده‌سازی برای اضافه شدن به کارسود می‌باشد
                                و کلی
                                خدمات و امکانات دیگر که در آینده به این سیستم اضافه خواهد شد، همه این‌ خدمات و
                                امکانات
                                نیازهای روزمره شما را تامین خواهد کرد و شما در ازای استفاده از این خدمات،
                                تبلیغات با
                                کارمزدهای مختلف پاداش می گیرید و با کلیک روی این تبلیغات درآمد کسب می کنید.
                                جالبه بدانید
                                هزینه استفاده از همه این خدمات را می‌توانید از درآمدتان در کارسود پرداخت
                                کنید.</p>
                            <p>حتی می‌توانید تورهای مسافرتی داخلی و خارجی را به صورت اقساطی تهیه نمایید و اقساط
                                آن را از
                                درآمدتان پرداخت کنید.</p>
                            <p>همچنین در صورت تمایلتان ، این امکان برای شما وجود دارد تا همه خدمات، محصولات و
                                امکانات
                                روی کارسود را به سایرین بفروشید و از این طریق نیز درآمد کسب کنید.</p>
                            <p>👈یکی دیگر از راه‌هایی که می‌توانید تبلیغات خیلی زیاد و همیشگی بگیرید معرفی کارسود
                                به
                                دیگران می باشد، زمانی که سایرین با کد دعوت شما ثبت نام کنند و شروع به فعالیت
                                کنند،
                                کارسود به شما تبلیغ می‌دهد و شما از هر نفری که با کد شما ثبت نام کند و عضو
                                کارسود شود،
                                می توانید درآمد همیشگی و نامحدود داشته باشید. این افراد هر کاری که در کارسود
                                انجام دهند
                                و از هر خدمات و امکاناتی که استفاده کنند و یا فروش انجام دهند، هم خودشان درآمد
                                کسب
                                می‌کنند و هم اینکه به شما که معرف آنها هستید تبلیغ و درآمد داده می‌شود، هرچه
                                بیشتر این
                                افراد در کارسود فعالیت کنند و هرچه بیشتر درآمد کسب کنند، درآمد شما نیز بیشتر
                                خواهد شد و
                                تبلیغات بیشتری با کارمزد های بالاتر پاداش میگیرید، زیرا این افراد را شما معرفی
                                کرده‌اید
                                و به آنها کمک کرده اید که به درآمد برسند، این تبلیغات و درآمدهایی که از این
                                افراد
                                می‌گیرید در واقع کارمزد و پاداش معرفی و کمک به این افراد است.</p>
                            <p className={"text-center"}>
                                <button className={'btn btn-primary me-3   bg-primary centered'}
                                    onClick={() => setIsOpenModal(false)}>مشاهده شد
                                </button>
                            </p>

                        </div>

                    </div>

                </div>
            </Modal>
        </>
    )
}